import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-500">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  if (user.must_change_password && location.pathname !== "/sifre-degistir") return <Navigate to="/sifre-degistir" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
}
